import httpwmsapi from '../httpwmsapi';
import httpfb from '../httpfb';
import http from './index';
import { triggerSessionExpiredModal } from '../sessionExpired';

const getToken = () => localStorage.getItem('accessToken');

const validateToken = (token) => {
  if (token) {
    // let dateNow = new Date();
    //const decoded = jwt_decode(token);
    // return decoded.exp < dateNow.getTime();
    return true;
  }
  return false;
};

const handleInvalidToken = () => {
  triggerSessionExpiredModal();
};

const createRequestInterceptor = (httpInstance) => {
  return httpInstance.interceptors.request.use((config) => {
    const token = getToken();
    if (token) {
      if (validateToken(token)) {
        config.headers.Authorization = `Bearer ${token}`;
      } else {
        handleInvalidToken();
      }
    }
    return config;
  });
};

const createResponseInterceptor = (httpInstance) => {
  return httpInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      const message = error?.response?.data?.erro || error?.response?.data?.message;

      const isTokenError = status === 401 || message === 'Token inválido' || message === 'SESSION_EXPIRED';

      if (isTokenError && window.location.pathname !== '/login') {
        handleInvalidToken();
        return Promise.reject(error);
      }

      return Promise.reject(error);
    }
  );
};

const requestInterceptor = (store) => {
  const instances = [httpwmsapi, httpfb, http];
  instances.forEach((instance) => {
    createRequestInterceptor(instance);
    createResponseInterceptor(instance);
  });
};

export { requestInterceptor };
